import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {OrbitSwiperComponent} from '../orbit-swiper/orbit-swiper.component';
import {observer} from 'mobx-react';
import {ISwiperListViewModel} from "../../services/arenas/models/lists/swiper-list-view-model.interface";

interface RecentlyPlayedComponentProps {
  viewModel: ISwiperListViewModel;
  listPosition: number
}

export const RecentlyPlayedComponent = observer(
  class RecentlyPlayedComponent extends OrbitComponent<RecentlyPlayedComponentProps> {

    render() {
      const viewModel = this.props.viewModel;
      let numberOfPlaceholders = Math.max(0, 6 - viewModel.gameTypes.length);

      return (
          <OrbitSwiperComponent viewModel={viewModel} className='cy-recently-played'
                                numberOfPlaceholders={numberOfPlaceholders}
                                listPosition={this.props.listPosition}
                                skipIntermediatePage={true}
          />
      );
    }
  }
);


